<template>
  <div>
    <the-header/>
    <div class="d-flex justify-content-center">
      <blank-document/>
    </div>
    <modal :width="modalConfig.width"
           :disableHeader="true"
           :disableFooter="true">
      <template #body>
        <div class="d-flex flex-column align-items-center">
          <span class="c-ff4848 mb-4">
            <i class="far fa-exclamation-circle fa-5x"/>
          </span>
          <div class="d-flex flex-column">
             <span class="f-bold s-16 mb-3">
                You may be using an outdated version of your browser or have an AdBlocker extension enabled, which can prevent us from accessing certain information.
             </span>
            <span class="f-bold s-16 mb-2">
                To avoid any inconvenience, please update your browser or disable AdBlocker.
            </span>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'TrackerInfo',
  data() {
    return {
      modalConfig: {
        width: 700,
      },
    };
  },
  components: {
    TheHeader: () => import('../components/TheHeader.vue'),
    BlankDocument: () => import('@/modules/validate_landing/components/BlankDocument.vue'),
    Modal: () => import('@/modules/common/components/modal/Modal.vue'),
  },
};
</script>

<style scoped>
.c-ff4848 {
  color: #ff4848;
}
</style>
